import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import {AuthentificationService} from './core/services/authentification.service';
import {LoaderService} from './core/services/loader.service';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../environments/environment';
import {VersionCheckService} from './core/services/version-check.service';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';
import {Title} from '@angular/platform-browser';
import {MaintenanceCheckService} from './core/services/maintenance-check.service';
import {RequestCancellationService} from "./core/services/requestCancellationService";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styles: [
        `
                        .view {
                            margin-top: 30px;
                        }

                        .slider {
                            position: fixed;
                            width: 100%;
                            height: 5px;
                            overflow-x: hidden;
                            z-index: 1000;
                            top: 0;
                            left: 0;
                            right: 0;

                        }

                        .line {
                            position: absolute;
                            opacity: 0.4;
                            background: #34b1c5;
                            width: 150%;
                            height: 5px;
                        }

                        .subline {
                            position: absolute;
                            background: #34b1c5;
                            height: 5px;
                        }

                        .inc {
                            animation: increase 2s infinite;
                        }

                        .dec {
                            animation: decrease 2s 0.5s infinite;
                        }

                        #environment-badge{
                            position: fixed;
                            top: 6px;
                            left: 15px;
                            display: block;
                            padding: 0 4px;
                            border-radius: 4px;
                            color: white;
                            background: black;
                            z-index: 99999;
                            font-size: 11px;

                            &.environment-REC{
                                background-color: #C42626;
                            }
                            &.environment-DEV{
                                background-color: #0049E5;
                            }
                            &.environment-UAT{
                                background-color: #FFCD00;
                            }
                        }

                        @keyframes increase {
                            from {
                                left: -5%;
                                width: 5%;
                            }
                            to {
                                left: 130%;
                                width: 100%;
                            }
                        }

                        @keyframes decrease {
                            from {
                                left: -80%;
                                width: 80%;
                            }
                            to {
                                left: 110%;
                                width: 10%;
                            }
                        }


                    `,
    ],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
    translate = inject(TranslateService);
    authService = inject(AuthentificationService);
    loaderService = inject(LoaderService);
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private versionCheckService = inject(VersionCheckService);
    maintenanceCheckService = inject(MaintenanceCheckService);
    private titleService = inject(Title);
    private requestCancellationService = inject(RequestCancellationService);

    public title = 'Fondation ARC - site AAP';
    public userIsValid = true;
    public loader = false;
    public environment = environment;
    private subscriptions: any[] = [];

    constructor() {
        let locale = null;
        if (this.authService.userConnected !== null && this.authService.userConnected !== undefined) {
            locale = this.authService.userConnected['locale'];
        }
        if (locale == null) {
            locale = window.localStorage.getItem('langue');
        }
        if (locale == null) {
            locale = this.translate.getBrowserLang();
            if (locale !== 'fr') {
                locale = 'en';
            }
        }



        this.translate.setDefaultLang(locale);
        this.translate.use(locale);


        /*const urlIgnored = [
            "/connexion/load-user",
            "assets"
        ]

        let lastRoute = "";
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
               let shouldCancel = true;

              urlIgnored.forEach(url => {
                if(event.url.indexOf(url) !== -1) {
                    shouldCancel = false;
                }
              });

              if(shouldCancel) {
                this.requestCancellationService.cancelPendingRequests(); // Annule les requêtes en cours
              }
            }
            if(event instanceof NavigationEnd) {
                lastRoute = event.url;
            }
        });*/
    }

    ngOnInit() {

        if (
            this.authService.isLoggedIn() &&
            !this.authService.isAdmin() &&
            this.authService.userConnected['inscriptionComplete'] === false
        ) {
            this.userIsValid = false;
        }

        if (environment.checkVersion) {
            this.versionCheckService.initVersionCheck(environment.versionCheckUrl);
        }

        this.maintenanceCheckService.initCheck();

        const titlePrefix = environment.production ? '': '[' + environment.sentryEnvironment + '] ';

        this.router
            .events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => {
                let child = this.activatedRoute.firstChild;
                while (child.firstChild) {
                    child = child.firstChild;
                }

                child.url.subscribe(res => {
                    const body: HTMLElement = document.getElementsByTagName('body')[0];
                    if (child.snapshot.data['hideMenu'] || res.length > 0 && res[res.length - 1].path === 'viewMode') {
                        body.classList.add('menu-hidden');
                    }else{
                        body.classList.remove('menu-hidden');
                    }
                });

                if (child.snapshot.data['title']) {
                    return this.translate.instant(child.snapshot.data['title']);
                }
                return this.title;
            })
        ).subscribe((ttl: string) => {
            this.titleService.setTitle(titlePrefix + ttl);
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(element => {
            if (element) {
                element.unsubscribe();
            }
        });
    }



    ngAfterViewInit() {
        this.subscriptions[1] = this.loaderService.observer.subscribe(res => {
            setTimeout(() => {
                if (res && +res > 0) {
                    this.loader = true;
                } else if (res === 0) {
                    this.loader = false;
                }
            }, 0);
        });

    }
}
